import axiosInstance from "@/services/https/global";
import axios from "axios";
import CONFIG from "@/config";
const roleUrl = `${CONFIG.BASE_URL}/wayapay-role-access`;
const baseUrl = `${CONFIG.BASE_URL}/auth-service/api/v1`;

export const createAdminRole = async (payload) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/admin/manage-user/create-admin-roles`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const changeAdminRole = async ({ userId, payload }) => {
  try {
    const response = await axiosInstance.put(
      `${baseUrl}/admin/manage-user/update-admin-role/${userId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 400) {
        throw error.response.data;
      }
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getMerchantTeamsRoles = async () => {
  try {
    const response = await axiosInstance.get(
      `${roleUrl}/admin/merchants/get_merchant_team_roles`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getMerchantTeams = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.invitorId !== undefined) queryParams.invitorId = params.invitorId;
  if (params.roleName !== undefined) queryParams.roleName = params.roleName;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(
      `${roleUrl}/admin/merchants/team`,
      {
        params: queryParams,
      },
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAdminUsersStats = async () => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/admin/user/stats`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAdminRoles = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/admin/manage-user/fetch-admin-roles`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAdminUsers = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.roleName !== undefined) queryParams.role = params.roleName;

  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(`${baseUrl}/user/admin-users`, {
      params: queryParams,
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};

export const getAdminUserById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/user/admin-users/${id}`,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw error.response?.data || error;
    }
    throw new Error("An unexpected error occurred");
  }
};
